import Modals from 'singletons/Modals'
import BasicInfo from 'components/Dashboard/cards/common/BasicInfo'
import convertSpecialty from 'util/convertSpecialty'
import { phoneInputFormat } from 'util/formatters'

import Visit from 'types/Visit'
import Divider from 'components/common/Divider'
import { PharmacyModel } from 'types/Visit/PendingVisit'

type PharmacyProps = {
  visit: Visit
  pharmacy: PharmacyModel
  isChangeButtonShown: boolean
}

const Pharmacy = ({ visit, isChangeButtonShown, pharmacy }: PharmacyProps) => {
  const { address1, city, state, zip, phone, specialty, storeName } = pharmacy

  return (
    <>
      <div className="flex justify-between items-center">
        <div>
          <p className="text-neutral typography-body-l">{storeName}</p>
          <BasicInfo address={address1} state={`${city}, ${state} ${zip}`} phone={phoneInputFormat(phone)} />
          <p className="text-neutral typography-body-l">{convertSpecialty(specialty)}</p>
        </div>

        {isChangeButtonShown && (
          <button
            className="btn btn-primary-outlined mt-3 mb-8"
            type="button"
            onClick={() => Modals.open('changePharmacy', { visit })}
          >
            Change
          </button>
        )}
      </div>
      <Divider />
    </>
  )
}

export default Pharmacy
